import React from 'react';

const ModalApproval = ({show}) => {
    const [data, setData] = React.useState({
        showModal: show
    })
    const hideModal = () => {
        setData({
            ...data,
            showModal: !data.showModal,
        })
    }

    if (!data.showModal) {
        return null;
    } else {
        return (
            <div className="mod-approve-container" onClick={() => {
                hideModal()
            }}>
                Test Modal
            </div>
        );
    }
}

export default ModalApproval;
